import { render } from "./translate.vue?vue&type=template&id=30865448&scoped=true"
import script from "./translate.vue?vue&type=script&lang=js"
export * from "./translate.vue?vue&type=script&lang=js"

import "./translate.vue?vue&type=style&index=0&id=30865448&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30865448"]])

export default __exports__